(function($, undefined) {
	"use strict";
	
	function init() {
		$('.tooltip').on('mouseenter focusin', showTooltip);
	}

	function showTooltip({ currentTarget, type }) {
		const t = $(currentTarget);
		const text = t.find('.tooltip__text');
		const clone = text.clone().css('position', 'fixed');

		$(document.body).append(clone);
		text.css('min-width', clone.outerWidth());
		clone.remove();
		
		t.addClass(`tooltip_${type}`);

		if (text.outerWidth() + text.offset().left > $(window).innerWidth()) {
			repositionText(text);
		}

		t.on('mouseleave focusout', hideTooltip);
	}

	function hideTooltip({ currentTarget, type }) {
		const t = $(currentTarget);
		const text = t.find('.tooltip__text');

		if (type === 'mouseleave') {
			t.removeClass('tooltip_mouseenter');
		} else {
			t.removeClass('tooltip_focusin');
		}

		if (!t.hasClass('tooltip_mouseenter') && !t.hasClass('tooltip_focusin')) {
			t.off('mouseleave focusout', hideTooltip);
			text.removeAttr('style');
		}
	}

	function repositionText(text) {
		const offsetToCenter = Math.abs(text.offset().left + text.outerWidth() / 2 - $(window).innerWidth() / 2);

		if (offsetToCenter >= text.outerWidth() - 10) {
			text.css({
				left: 'auto',
				right: 0
			});
		} else {
			text.css('left', -Math.abs(offsetToCenter));
		}
	}
	
	$(init);
	
})(jQuery);